import { storage } from '@uhg-abyss/web/tools/storage';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import {
  PcpEmailEligibilityState,
  STATUS,
  StoreKeys,
  initialState,
} from './pcpEmailStore';

const PCP_EMAIL_STORE_KEY = 'pcpEmailStore';

const store = (set) => ({
  ...initialState,
  [StoreKeys.SET_PCP_EMAIL_ELIGIBILITY_DATA]: (values) =>
    set(() => ({ [StoreKeys.PCP_EMAIL_ELIGIBILITY_DATA]: values })),
  [StoreKeys.CLEAR_PCP_EMAIL_ELIGIBILITY_DATA]: () => {
    storage.session.remove(PCP_EMAIL_STORE_KEY);
    set(() => ({
      [StoreKeys.PCP_EMAIL_ELIGIBILITY_DATA]: {},
      [StoreKeys.STATUS]: STATUS.IDLE,
    }));
  },
  [StoreKeys.SET_STATUS]: (value) => set(() => ({ [StoreKeys.STATUS]: value })),
});

const pcpEmailStore = persist(store, {
  name: PCP_EMAIL_STORE_KEY,
  storage: createJSONStorage(() => sessionStorage),
  merge: (
    persistedState: PcpEmailEligibilityState,
    currentState: PcpEmailEligibilityState
  ) => ({
    ...currentState,
    ...persistedState,
  }),
});

export const usePcpEmailEligibilityStore = create(devtools(pcpEmailStore));
